/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlayType {
    SETUP = 'SETUP',
    LCA = 'LCA',
}
